export default __webpack_public_path__ + "static/media/icon-home-light.0f6e94a2.svg";